import { Box, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material'
import { useCallback } from 'react'

export const NotAuthenticatedPage = () => {
  const handleAuth = useCallback(async (token: string) => {
    const response = await fetch(phoenix.runtimeConfig.SERVER_URL + '/environments/authorize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientId: phoenix.runtimeConfig.ENVIRONMENT_ID,
        accessToken: token,
        refreshToken: token,
      }),
    })

    const { callback } = await response.json()

    location.href = callback
  }, [])

  const hasUserToken = phoenix.runtimeConfig.FAKE_AUTH_USER_TOKEN.length > 0
  const hasAdminToken = phoenix.runtimeConfig.FAKE_AUTH_ADMIN_TOKEN.length > 0

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" flexDirection="row" gap={4}>
      {hasAdminToken && (
        <Card sx={{ maxWidth: 345 }}>
          <CardHeader title="Login as admin" />
          <CardContent>
            <Typography variant="body1">Log in as an admin to access the configurator and the admin panel.</Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => handleAuth(phoenix.runtimeConfig.FAKE_AUTH_ADMIN_TOKEN)}>Login</Button>
          </CardActions>
        </Card>
      )}
      {hasUserToken && (
        <Card sx={{ maxWidth: 345 }}>
          <CardHeader title="Login as user" />
          <CardContent>
            <Typography variant="body1">Log in as a user to access just the configurator.</Typography>
          </CardContent>
          <CardActions>
            <Button onClick={() => handleAuth(phoenix.runtimeConfig.FAKE_AUTH_USER_TOKEN)}>Login</Button>
          </CardActions>
        </Card>
      )}

      {!hasUserToken && !hasAdminToken && (
        <>
          <img src="/davcor-logo.webp" alt="Davcor logo" />
          <div>
            You’re currently not logged in. Please log back in to{' '}
            <a href={phoenix.runtimeConfig.DAVEWEB_URL} title="Go to Daveweb">
              Daveweb
            </a>{' '}
            to access this page.
          </div>
        </>
      )}
    </Box>
  )
}
